import * as $ from "jquery";
import * as ko from "knockout";
import BaoDialogViewModel from "../../factories/bao-dialog";
import Bao from "../../services/bao-service";
import template from "./tenant-switcher.html";

export interface ITenantModel {
	Id: string | KnockoutObservable<string>;
	Number: string | KnockoutObservable<string>;
	Name: string | KnockoutObservable<string>;
}

export class TenantSwitcher {

	public AutoSelect = true;

	public Result = false;
	public LanguageSymbol = undefined;

	private ClientId = ko.observable<string>();
	private Active = ko.observable(true);
	private SelectedIndex = ko.observable(0);
	private ClientCollection = ko.observableArray<ITenantModel>();
	private IsLoading = ko.observable(false);
	private subs: KnockoutSubscription[] = [];
	private ignoreSelect: boolean = false;
	private InfoDialog: BaoDialogViewModel;
	private Dialog: BaoDialogViewModel;
	private invokedManually: boolean;

	constructor(invokedManually: boolean = false) {
		this.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
		this.InfoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
		this.InfoDialog.Width(400);
		this.invokedManually = invokedManually;

		this.subs.push(this.SelectedIndex.subscribe((value) => {
			this.SelectId(this.ClientCollection()[value]);
		}));
		this.ClientId.subscribe((newid) => {
			if (newid != null) {
				this.Dialog.Buttons()[0].Enabled(true);
			} else {
				this.Dialog.Buttons()[0].Enabled(false);
			}
		});
		$(document).on("keydown", this.EventKeyDownDoc);
	}

	public SelectId(selectedClient) {
		this.ClientId(selectedClient.Id());
		if (this.ignoreSelect == false) {
			this.Dialog.Buttons()[0].Click();
		} else {
			this.ignoreSelect = false;
		}
	}

	public dispose() {
		this.subs.forEach((d) => {
			d.dispose();
		});
		$(document).off("keydown", this.EventKeyDownDoc);
		this.Dialog.dispose();
		this.InfoDialog.dispose();
	}
	public Open(): JQueryPromise<boolean> {
		const def = $.Deferred<boolean>();
		this.IsLoading(true);
		Bao.post("Login/GetSelectClient", (value) => {
			if (this.AutoSelect && value.ClientId != null) {
				this.ClientId(value.ClientId);
				this.SelectClient(true).then((result) => {
					if (result) {
						this.Result = true;
						this.dispose();
						def.resolve(true);
					}
				});
			} else {
				this.initDialog(def.resolve);
				ko.map.fromJS(value.Model, this);
				this.Dialog.Open().then(() => {
					def.resolve(this.Result);
				});
			}
			this.IsLoading(false);
		});
		return def.promise();
	}

	private initDialog(resolve: (result: boolean) => void) {
		const captionOK = Bao.Session.GetMessage("msgOk");
		const captionCancel = Bao.Session.GetMessage("msgCancel");

		this.Dialog.VerticalMode("middle");
		this.Dialog.Width(400);
		this.Dialog.Template(template);
		this.Dialog.Buttons([{
			Title: captionOK,
			Click: () => {
				this.SelectClient(false).then((result) => {
					if (result) {
						this.dispose();
						resolve(true);
					}
				});
			},
			Enabled: ko.observable(false)
		}, {
			Title: captionCancel,
			Click: () => {
				this.Active(false);
				this.Dialog.Close();
				this.dispose();
				resolve(false);
			},
			Enabled: ko.observable(true)
		}]);
		this.Dialog.ViewModel(this);

	}

	private EventKeyDownDoc = (e) => {
		if (e.keyCode == 38) {
			if (this.SelectedIndex() > 0) {
				this.ignoreSelect = true;
				this.SelectedIndex(this.SelectedIndex() - 1);
			}
		} else if (e.keyCode == 40) {
			if (this.ClientCollection != null && this.ClientCollection().length > 0 && this.SelectedIndex() < this.ClientCollection().length - 1) {
				this.ignoreSelect = true;
				this.SelectedIndex(this.SelectedIndex() + 1);
			}
		} else if (e.keyCode == 13) {
			if (this.Active()) {
				this.Dialog.Buttons()[0].Click();
			}
		}
	}

	private SelectClient(clientIsPreselected: boolean) {
        const def = $.Deferred();
        if (this.ClientId() != null) {
            this.InfoDialog.IsLoading(true);

			this.ContinueLoggingIn(clientIsPreselected)
				.then(result => {
					if (!result) {
                        def.resolve(false);
                        return;
                    }
                    Bao.post("Login/SelectClient", JSON.stringify({
                        clientId: this.ClientId()
                    }), (value) => {
                        if (value.Result == true) {
                            def.resolve(true);
                        } else {
                            this.InfoDialog.IsLoading(false);
                            this.InfoDialog.Template(value.Message);
                            this.InfoDialog.Open().then(() => {
                                def.resolve(false);
                            });

                        }
                    })
                    .fail((value) => {
                        this.InfoDialog.Template(value);
                        this.InfoDialog.Open().then(() => {
                            def.resolve(false);
                        });
                    })

                })
                .fail((value) => {
                    this.InfoDialog.Template(value);
                    this.InfoDialog.Open().then(() => {
                        def.resolve(false);
                    });
                });
            return def.promise();
        }
	}

	/**
	 * Returns true if logging in should be contunue 
	 * Returns false if a user is logged into the browser and displays the message
	 * @param autoMode true if client is preselected  (without dialog)
	 */
	private ContinueLoggingIn(clientIsPreselected: boolean): JQueryPromise<boolean> {
		if (clientIsPreselected || this.invokedManually) {
			return $.Deferred().resolve(true).promise();
        }

		return Bao.Session.RenewSession()
			.then(result => {
				if (result) {
					new BaoDialogViewModel(Bao.Session.ApplicationName,
						this.LanguageSymbol === undefined
							? Bao.Session.GetMessage("msgAlreadyLoggedUserInTheBrowser")
							: Bao.Session.GetMessageBySymbol("msgAlreadyLoggedUserInTheBrowser", this.LanguageSymbol),
						"info");
					this.InfoDialog.IsLoading(false);
					return false;
				}
				return true;
			});
	}
}
